import { render, staticRenderFns } from "./StatuswiseAgent.vue?vue&type=template&id=5cf2202f&scoped=true"
import script from "./StatuswiseAgent.vue?vue&type=script&lang=js"
export * from "./StatuswiseAgent.vue?vue&type=script&lang=js"
import style0 from "./StatuswiseAgent.vue?vue&type=style&index=0&id=5cf2202f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf2202f",
  null
  
)

export default component.exports